/*
 * @Author: CAIPENG\CaiPeng 405532928@qq.com
 * @Date: 2022-11-05 15:04:03
 * @LastEditors: CAIPENG\CaiPeng 405532928@qq.com
 * @LastEditTime: 2023-04-18 11:10:42
 * @FilePath: \xm\xm-runing-main\src\migo\apps.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getAppEnvConfig } from '@/utils/env';

const {
  VITE_GLOB_NGS,
  VITE_GLOB_ACCOUNT_MG,
  VITE_GLOB_PRO_MAIN_DES,
  VITE_GLOB_SUB_APP_XM_MILKYWAY_PC_REACT_VIEWER,
  VITE_GLOB_SUB_APP_WF_DEPLOY,
  VITE_GLOB_RUNGING_EXTEND,
  VITE_GLOB_SUB_APP_OPERATE_ACCOUNT,
  VITE_GLOB_SUB_APP_XM_ERP,
  VITE_GLOB_SUB_APP_XM_MES_PRO
} = getAppEnvConfig();

export const apps = [
  {
    name: 'XmMilkywayPcReactViewer',
    entry: VITE_GLOB_SUB_APP_XM_MILKYWAY_PC_REACT_VIEWER,
    container: '#frame',
    activeRule: '/xm-milkyway-pc-react-viewer',
  },
  {
    name: 'WfDeploy',
    entry: VITE_GLOB_SUB_APP_WF_DEPLOY,
    container: '#frame',
    activeRule: '/wf-deploy',
  },
  {
    name: 'xmMesPro',
    entry: VITE_GLOB_SUB_APP_XM_MES_PRO,
    container: '#frame',
    activeRule: '/xm-mes-pro'
  },
  {
    name: 'XmOperateAccount',
    entry: VITE_GLOB_SUB_APP_OPERATE_ACCOUNT,
    container: '#frame',
    activeRule: '/xm-operate-account',
  },
  {
    name: 'xmProMainDes',
    // entry: "http://10.50.160.10:32490/child/xm-pro-main-des",
    entry: VITE_GLOB_PRO_MAIN_DES,
    // entry: VITE_RUNGING_EXTEND,
    container: '#frame',
    activeRule: '/xm-pro-main-des',
  },
  {
    name: 'XmRuningExtend',
    // entry: 'http://localhost:3333',
    entry: VITE_GLOB_RUNGING_EXTEND,
    container: '#frame',
    activeRule: '/xm-runing-extend',
  },
  {
    name: 'XmAccountMg',
    // entry: 'http://localhost:3333',
    entry: VITE_GLOB_ACCOUNT_MG,
    container: '#frame',
    activeRule: '/xm-account-mg',
  },
  {
    name: 'XmPerformance',
    // entry: 'http://localhost:3333',
    entry: VITE_GLOB_NGS,
    container: '#frame',
    activeRule: '/xm-ngs',
  },
];

/**
 * 是否为乾坤子应用
 * @param appName
 */
export function isQianKunApp(appName){
  const itemObj=apps.filter((itemDb)=>{
    return itemDb.activeRule==="/"+appName;
  })[0];
  if(itemObj){
    return true;
  }else{
    return false;
  }
}
//预加载的应用
export const prefetchAppsList=[
  {
    name: 'xmErp',
    entry: VITE_GLOB_SUB_APP_XM_ERP,
  },
  {
    name: 'XmMilkywayPcReactViewer',
    entry: VITE_GLOB_SUB_APP_XM_MILKYWAY_PC_REACT_VIEWER,
  },
  {
    name: 'XmRuningExtend',
    // entry: 'http://localhost:3333',
    entry: VITE_GLOB_RUNGING_EXTEND,
  },
  {
    name: 'XmOperateAccount',
    entry: VITE_GLOB_SUB_APP_OPERATE_ACCOUNT,
  },
  {
    name: 'xmProMainDes',
    entry: VITE_GLOB_PRO_MAIN_DES,
  }
]

export default apps;
